module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extend.js
// module id = 4320
// module chunks = 168707334958949